// work with node-version:12.22.12 npm-version:6.14.16
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { v4 as uuidv4 } from "uuid";

Vue.use(ElementUI);

Vue.config.productionTip = false

import axios from 'axios'

const axiosService = axios.create({
  method: "POST"
})

// Vue.prototype.$baseUrl = "https://szmp.qilushop.cn";
Vue.prototype.$baseUrl = "https://opencloud.ingnet.cn";

axiosService.interceptors.request.use((req) => {

  req.headers["content-type"] = "application/x-www-form-urlencoded"

  const isLoginUrl = (req.url.includes(`/addons/third/api/getAuthUrl`) || req.url.includes(`/addons/third/api/callback`));
  req.headers["token"] = window.localStorage.getItem("token");

  if (!window.localStorage.getItem("uuid")) {
    const uuid = uuidv4();
    window.localStorage.setItem("uuid", uuid);
  }

  if (isLoginUrl) {
    req.headers["sid"] = window.localStorage.getItem("uuid");
  }
  return req;
})

axiosService.interceptors.response.use((res) => {
  return res.data;
  // unauth.
}, (error) => {
  if (error.response.status == 401) {
    router.push("/userLogin");
    window.localStorage.removeItem("token");
  }
})

Vue.prototype.$post = function (url, data, config) {
  return axiosService.post(`${Vue.prototype.$baseUrl}${url}`, data, config);
}

const vueInstance = new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  }
}).$mount('#app')

let loading;

Vue.prototype.$startLoading = () => {
  loading = vueInstance.$loading({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, 0.6)'
  });
}

Vue.prototype.$stopLoading = () => {
  loading.close();
}